import React, { useState } from "react";

interface CollapsibleGroupProps {
  title: string;
  children: React.ReactNode;
  initiallyExpanded?: boolean;
}

const CollapsibleGroup: React.FC<CollapsibleGroupProps> = ({
  title,
  children,
  initiallyExpanded = true,
}) => {
  const [expanded, setExpanded] = useState(initiallyExpanded);

  return (
    <div className="collapsible-group">
      <div
        className="collapsible-header"
        onClick={() => setExpanded(!expanded)}
      >
        <h3 style={{ margin: 0 }}>{title}</h3>
        <span style={{ fontSize: "20px", fontWeight: "bold" }}>
          {expanded ? "-" : "+"}
        </span>
      </div>
      {expanded && (
        <div className="collapsible-content" style={{ marginTop: "10px" }}>
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleGroup;
